/*  英文包  */
import frLocale from 'element-ui/lib/locale/lang/fr'
const fy = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'Disque cloud',
        'headerlangSelect' : 'Veuillez sélectionner une langue',
        'headerLoginOut' : 'Se déconnecter',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'Tous les fichiers',
        'sideMenuPhoto' : 'Les photos',
        'sideMunsDoc' : 'Fichier',
        'sideMenuVideo' : 'Vidéo',
        'sideMenuSeed' : 'Seed',
        'sideMenuMusic' : 'La musique',
        'sideMenuOrther' : 'Autre',
        'sideMenuShareName' : 'Ma part',
        'sideMenuCollectName' : 'Corbeille',

        /*  用户语言设定 */
        'mainUpload' : 'Téléchargez',
        'mainBuildDir' : 'Nouveau dossier',
        'mainDownloadOutline' : 'Télécharger hors ligne',
        'mainSearch' : 'Fichier de recherche',
        'mainAllFile' : 'Tous les fichiers',
        'mainFile' : 'Fichier',
        'mainSize' : 'La taille',
        'mainDate' : 'Date',
        'mainFileDel' : 'Effacer',
        'mainConfirmDel' : 'Confirmer la suppression?',
        'sure' : 'Confirmer',
        'cancel' : 'Annuler',
        'mainReturn' : 'Retour à',
        'mainPagePrev' : 'Précédente',
        'mainPageNext' : 'Page suivante',
        'mainLoaded' : 'Chargé',
        'mainTotal' : 'Total',
        'mainUnit' : 'Bande',
        'dilatation' : 'Expansion',
        /*  回收站设定  */
        'mainHeaderTitle' : 'Conseil: la corbeille n\'occupe pas d\'espace disque réseau.',
        'mainHeaderButton' : 'Vider la corbeille',
        'collectName' : 'Corbeille',
        'mainRevertIts' : 'Restaurer',
        'mianDelData' : 'Supprimer l\'heure',

        'confirmClear' : 'Confirmer pour effacer les fichiers sélectionnés? (Impossible de récupérer après effacement)',
        'confirmClearAll' : 'Voulez-vous vraiment vider la corbeille?',

        /*  其他设定 */
        'messageBoxTitle' : 'Indice',
        'messageBoxConfirmRevert' : 'Confirmez pour restaurer le fichier sélectionné?',
        'loading' : 'Chargement ...',
        'loaded' : 'Pas de données',

        'messageMoveTo' : 'Déplacer vers',
        'filterNotice' : 'Entrez des mots clés à filtrer',
        'messageLoaded' : 'Téléchargé:',
        'messageMovetion' : 'Déplacement de fichier',

        'messageMissKeyWord' : 'Veuillez saisir des mots clés de recherche',
        'messageFolderLayersLimit' : 'Échec de la création La profondeur de la hiérarchie des dossiers ne dépasse pas 5 niveaux',
        'messageSameFolderName' : 'La création a échoué Le même nom de fichier existe',
        'messageEmptyFolderName' : 'Veuillez saisir un nom de dossier',
        'messageMoveSame' : 'Impossible de déplacer vers le même dossier',
        'messageActionError' : 'L\'opération a échoué',
        'messageActionSuccess' : 'Opération réussie',
        'messageServerIsBusy' : 'Le serveur est occupé',
        'messageUploadOverLimit' : 'Trop de fichiers sélectionnés (dans les 5)',
        'messageDiskFreeFull' : 'Espace utilisateur insuffisant',
        'messageUploadTypeError' : 'Impossible de télécharger ce type de fichier',
        'messageUploadMaxSize' : 'Le fichier de téléchargement est trop volumineux (dans les 10M)',
        'messageUploadSuccess' : 'Téléchargé avec succès',
        'messageUploadFailed' : 'Échec du téléchargement',
        'messageDownloadFailed' : 'Échec du téléchargement'
    },
    ...frLocale
};

export default fy;



// WEBPACK FOOTER //
// ./src/i18n/langs/fy.js